import React from "react";
import { useTranslation } from "react-i18next";

interface TimeoutModalProps {
  onReset: () => void;
}

export const TimeoutModal: React.FC<TimeoutModalProps> = ({ onReset }) => {
  const { t } = useTranslation("common");

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-md p-4">
      <div className="bg-stone-50 dark:bg-stone-950 border border-stone-200 dark:border-amber-500/30 rounded-3xl max-w-md w-full p-8 text-center shadow-2xl text-stone-900 dark:text-stone-100 transition-all">
        <div className="w-16 h-16 bg-amber-500/10 text-amber-600 dark:text-amber-400 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-serif border border-amber-500/30">
          ⌛
        </div>
        <h3 className="text-xl font-serif font-bold text-stone-900 dark:text-stone-100 mb-2">
          {t("booking.timeoutTitle", "Termin rezerwacji upłynął")}
        </h3>
        <p className="text-xs font-serif text-stone-600 dark:text-stone-400 leading-relaxed mb-6">
          {t(
            "booking.timeoutDesc",
            "Rezerwujemy miejsca na 10 minut, aby uniknąć ich blokowania dla innych gości. Prosimy spróbować ponownie."
          )}
        </p>
        <button
          onClick={onReset}
          className="w-full py-3.5 bg-gradient-to-r from-amber-600 to-amber-700 hover:from-amber-500 hover:to-amber-600 text-white font-serif text-xs font-semibold uppercase tracking-widest rounded-xl transition shadow-lg shadow-amber-950/30 border border-amber-400/20 cursor-pointer"
        >
          {t("booking.tryAgain", "Spróbuj ponownie")}
        </button>
      </div>
    </div>
  );
};
